var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVideoTabFilled = function SvgVideoTabFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.784 15.393v-5.098a1.871 1.871 0 00-.556-1.366 2.067 2.067 0 00-1.405-.596H5.295a2.067 2.067 0 00-1.405.596 1.87 1.87 0 00-.556 1.366V29.9a1.87 1.87 0 00.556 1.366 2.07 2.07 0 001.405.596h23.528a2.067 2.067 0 001.405-.596c.367-.368.567-.858.556-1.366v-5.098l4.114 4.938c.6.718 1.769.295 1.769-.64V11.095c0-.935-1.17-1.358-1.769-.64l-4.114 4.938z",
    fill: "url(#videoTabFilled_svg__y5ju2q1dwa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.333 13.333h10m2.857 0h2.143",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "videoTabFilled_svg__y5ju2q1dwa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(11.6707 18.29748 -23.04944 14.70165 8.33 13.565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgVideoTabFilled;